import React from 'react';

const IconHamburgerMenu: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    focusable='false'
    role='presentation'
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    {...props}
    className={`icon icon-hb-menu${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M2 3c0-.552.488-1 1.09-1h9.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H3.09C2.489 4 2 3.552 2 3zm0 5c0-.552.488-1 1.09-1h9.82c.602 0 1.09.448 1.09 1s-.488 1-1.09 1H3.09C2.489 9 2 8.552 2 8zm1.09 4C2.489 12 2 12.448 2 13s.488 1 1.09 1h9.82c.602 0 1.09-.448 1.09-1s-.488-1-1.09-1H3.09z'
      fill=''
    />
  </svg>
);
export default IconHamburgerMenu;
